import * as $ from 'jquery';

$(document.documentElement).on('click', '.sizeGuideBtn', function() {
    $('.sizeChart, .__product, .__addDress, .__order').addClass("active");
    $('html').addClass("hideVertScroll");
});

$(document.documentElement).on('click', '.closeBtn', function() {
    $('.sizeChart, .__product, .__addDress, .__order').removeClass("active");
    $('html').removeClass("hideVertScroll");
});

$('body').click(function(e) {
    if (!$(e.target).closest('.sizeChart').length){
        $(".sizeChart, .__product, .__addDress, .__order").removeClass("active");
        $('html').removeClass("hideVertScroll");
    }
});